import CityPageTemplate from "../city-template/CityPageTemplate";
import { rehobothBeachConfig } from "./data";

export default function RehobothBeachPage() {
  return <CityPageTemplate config={rehobothBeachConfig} />;
}